import React, { useCallback, useState } from 'react'
import { formatLocal, formatUTC } from 'utils/date'
import { orderBy } from 'lodash'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import Popover from '@mui/material/Popover'
import { translate } from 'locales'

// Components
import { Button } from 'components'

// Styles
import * as S from './styles'
import chevronDown from 'assets/icons/chevron-down.svg'

// Utils
import { getTimes } from './utils'

// Services
import {
  handleSaveScheduleConfiguration,
  handleDeleteSchedule,
} from './services'

const OverlayConfig = ({
  info,
  occupations,
  selectedOccupation,
  setSelectedOccupation,
  country,
  selectedCountry,
  setSelectedCountry,
  handleOccupationSelection,
  newSchedule,
  setNewSchedule,
  doctorSchedule,
  setDoctorSchedule,
  setLoading,
}: any) => {
  const day = formatLocal(info?.event.startStr, 'yyyy-MM-dd')
  const [repeatSchedule, setRepeatSchedule] = useState(false)
  const locales = window.localStorage.getItem('@StarBem:lang')
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const [horizontalPlacement, setHorizontalPlacement] = useState<
    'left' | 'right'
  >('right')
  const open = Boolean(anchorEl)
  const isPendent = info?.event?.extendedProps.status === 'pendent'

  const openAt = (node: HTMLElement) => {
    const { right } = node.getBoundingClientRect()
    const hasRoomOnTheRight = window.innerWidth - right >= S.POPOVER_WIDTH + 16
    setHorizontalPlacement(hasRoomOnTheRight ? 'right' : 'left')
    setAnchorEl(node)
  }

  const locale = locales === 'en' ? 'en-us' : 'pt-br'
  const interval =
    selectedOccupation.slug === 'clinico-geral'
      ? 60
      : selectedOccupation?.attendance_time || 30

  const triggerRef = useCallback(
    (node: HTMLDivElement | null) => {
      if (node && isPendent) {
        openAt(node)
      }
    },
    [isPendent]
  )

  const handleClose = () => setAnchorEl(null)

  // const verifyLangs = () => {
  //   const en = info?.event?.extendedProps?.occupation?.language?.includes('CA')
  //   const pt = info?.event?.extendedProps?.occupation?.language?.includes('BR')
  //   const hasCountries = `(${en ? translate('schedule.english') : ''}${pt && en ? ', ' : ''}${
  //     pt ? translate('schedule.portuguese') : ''
  //   })`

  //   return `${hasCountries}`
  // }

  return (
    <>
      <S.EventContent ref={triggerRef} onClick={(e) => openAt(e.currentTarget)}>
        <p>
          {info?.event && info.event.extendedProps.status === 'confirmed' ? (
            <div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                }}
              >
                <div
                  style={{ display: 'flex' }}
                  title={info?.event?.extendedProps.occupation.name}
                >
                  {String(info?.event?.extendedProps.occupation.name).slice(
                    0,
                    10
                  )}
                </div>

                <DeleteOutlineIcon style={{ fontSize: 20 }} />
              </div>
              {/* {info?.event?.extendedProps.occupation.name === 'Psicologia' && (
                <div>{verifyLangs()}</div>
              )} */}
              {info?.event?.extendedProps.plans?.includes('Plantão') && (
                <div style={{ fontSize: '10px', marginTop: -1 }}>
                  {translate('schedule.attendancePlantão')}
                </div>
              )}
            </div>
          ) : (
            translate('schedule.notTitle')
          )}
        </p>
      </S.EventContent>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: horizontalPlacement === 'right' ? 'right' : 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: horizontalPlacement === 'right' ? 'left' : 'right',
        }}
      >
        {isPendent ? (
          <S.PopverContainer>
            <h3>
              {`${formatUTC(info?.event.startStr, 'EEEE, dd/MM')} - ${translate('schedule.of')} ${formatUTC(info?.event.startStr, 'HH:mm')} ${translate('schedule.at')} ${formatUTC(info?.event.endStr, 'HH:mm')}`}
            </h3>
            <S.PopoverBody>
              <h4>{translate('schedule.initAt')}</h4>
              <input
                value={formatUTC(info?.event.startStr, 'HH:mm')}
                disabled
              />

              <h4>{translate('schedule.endAt')}</h4>
              <S.SelectField>
                <select
                  value={newSchedule.end}
                  onChange={(e) =>
                    setNewSchedule({ ...newSchedule, end: e.target.value })
                  }
                >
                  {getTimes(
                    formatUTC(info?.event.startStr, "yyyy-MM-dd'T'HH:mm:ss'Z'"),
                    interval
                  ).map((time) => (
                    <option key={time} value={`${day}T${time}:00Z`}>
                      {time}
                    </option>
                  ))}
                </select>
                <S.SelectIcon src={chevronDown} alt="expandir" />
              </S.SelectField>

              <h4>{translate('schedule.occupationArea')}</h4>

              {occupations && (
                <S.SelectField>
                  <select
                    value={selectedOccupation.id}
                    onChange={(e) => handleOccupationSelection(e)}
                  >
                    <option disabled>Selecionar</option>
                    {orderBy(occupations, ['areaName'], ['asc'])?.map(
                      (area: any) => (
                        <option key={area.id} value={area.id}>
                          {area.name}
                        </option>
                      )
                    )}
                  </select>
                  <S.SelectIcon src={chevronDown} alt="expandir" />
                </S.SelectField>
              )}
              <div className="form-checkbox" key="scheduleRepetition">
                <label htmlFor="scheduleRepetition" className="group-checkbox">
                  <input
                    id="scheduleRepetition"
                    checked={repeatSchedule}
                    type="checkbox"
                    onChange={() => setRepeatSchedule(!repeatSchedule)}
                  />
                  {translate('schedule.recurrence')}
                </label>
              </div>

              {/* {['psicologo'].includes(selectedOccupation.slug) && (
                <>
                  <h4>{translate('schedule.country')}</h4>
                  {country && (
                    <div>
                      {country.includes('BR') && (
                        <Checkbox
                          label={translate('schedule.portuguese')}
                          checked={selectedCountry.includes('BR')}
                          onChange={handleCountrySelection}
                          name="country"
                          id="BR"
                        />
                      )}
                      {country.includes('CA') && (
                        <Checkbox
                          label={translate('schedule.english')}
                          checked={selectedCountry.includes('CA')}
                          onChange={handleCountrySelection}
                          name="country"
                          id="CA"
                        />
                      )}
                    </div>
                  )}
                </>
              )} */}

              <>
                <h4>{translate('schedule.attendanceFormat')}</h4>
                <p>{translate('schedule.attendance')}</p>
              </>
              <Button
                type="button"
                color="primary"
                size="small"
                className="buttonHighlight"
                // disabled={
                //   ['psicologo'].includes(selectedOccupation.slug) &&
                //   !selectedCountry.includes('CA') &&
                //   !selectedCountry.includes('BR')
                // }
                onClick={() =>
                  handleSaveScheduleConfiguration(
                    occupations,
                    selectedOccupation,
                    setSelectedOccupation,
                    country,
                    selectedCountry,
                    setSelectedCountry,
                    newSchedule,
                    setNewSchedule,
                    doctorSchedule,
                    setDoctorSchedule,
                    setLoading,
                    repeatSchedule
                  )
                }
              >
                {translate('schedule.save')}
              </Button>

              <div className="button-cancel-schedule">
                <button type="submit" onClick={() => setNewSchedule({})}>
                  {translate('schedule.cancel')}
                </button>
              </div>
            </S.PopoverBody>
          </S.PopverContainer>
        ) : (
          <S.PopverContainer>
            <h3>{translate('schedule.appointment')}</h3>
            <S.PopoverBody>
              <h4>
                <h4>{formatUTC(info.event.startStr, 'EEEE, dd/MM')}</h4>
                <span
                  style={{
                    display: 'block',
                    marginTop: 12,
                    fontWeight: 'normal',
                  }}
                >
                  {`Das ${formatUTC(info.event.startStr, 'HH:mm')} às ${formatUTC(info.event.endStr, 'HH:mm')}`}
                </span>
              </h4>

              <Button
                type="button"
                color="danger"
                size="small"
                className="buttonHighlight"
                onClick={() =>
                  handleDeleteSchedule(
                    info?.event.id,
                    info?.event.extendedProps.plans,
                    doctorSchedule,
                    setDoctorSchedule,
                    setLoading
                  )
                }
              >
                {translate('schedule.remove')}
              </Button>
            </S.PopoverBody>
          </S.PopverContainer>
        )}
      </Popover>
    </>
  )
}

export default OverlayConfig
